import { render, staticRenderFns } from "./actionAlert.template?vue&type=template&id=23fe957e&lang=pug&"
import script from "./actionAlert.client?vue&type=script&lang=ts&"
export * from "./actionAlert.client?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/flypaper/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23fe957e')) {
      api.createRecord('23fe957e', component.options)
    } else {
      api.reload('23fe957e', component.options)
    }
    module.hot.accept("./actionAlert.template?vue&type=template&id=23fe957e&lang=pug&", function () {
      api.rerender('23fe957e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/widgets/actionAlert/actionAlert.component.vue"
export default component.exports